<template>
  <div>
    <name-input
      v-if="currentStage === 'name'"
      :user="users"
      :startedField="'started'"
      @idChanged="lookupComp"
      @startCountdown="startCountdown"
    />
    <countdown v-if="currentStage === 'countdown'" @startGame="startGame" />
    <puzzle
      v-if="currentStage === 'puzzle'"
      :number="puzzleNumber"
      :name="`/spot/comp/${puzzleNumber}-min.png`"
      :options="options[puzzleNumber - 1]"
      :description="questions[puzzleNumber - 1]"
      :keyboard="false"
      :countdown="false"
      :largeButtons="true"
      @complete="puzzleComplete"
    />
    <pause v-if="currentStage === 'pause'" @nextPuzzle="nextPuzzle" />
    <game-over
      v-if="currentStage === 'gameover'"
      :user="user.name"
      :time="userTime"
      :score="userScore"
      :error="error"
    />
  </div>
</template>

<script>
import Countdown from '@/components/Countdown'
import Puzzle from '@/components/PuzzleTall'
import Pause from '@/components/Pause'
import NameInput from '@/components/NameInput'
import GameOver from '@/components/GameOver'

import firebase from 'firebase/app'
import 'firebase/firestore'

const db = firebase.firestore()

export default {
  components: {
    Countdown,
    Puzzle,
    Pause,
    GameOver,
    NameInput,
  },

  data: function() {
    return {
      puzzleNumber: 1,
      currentStage: 'name',
      choices: [],
      times: [],
      userScore: '',
      userScoreNumber: 0,
      userTime: 0,
      user: {},
      users: {},
      error: 1,
      solution: [
        'Building',
        '4',
        '2',
        '5',
        'Green Vegetation',
        'Erosion Gully',
        'Cliff/ Crag',
        'Open',
        'Distinctive Tree',
        'Track/ Path/ Ride',
        'Green Vegetation',
        'Contour',
      ],
      options: [
        ['Tree', 'Contour', 'Building', 'Path'],
        ['3', '4', '5', '6'],
        ['0', '1', '2', '3'],
        ['2', '3', '4', '5'],
        ['Green Vegetation', 'Path', 'Open', 'Fence'],
        ['Distinctive Tree', 'Erosion Gully', 'Narrow Marsh', 'Boulder'],
        ['Path', 'Boulder', 'Cliff/ Crag', 'Fence'],
        ['Open', 'Distinctive Tree', 'Path', 'Knoll'],
        ['Boulder', 'Distinctive Tree', 'Erosion Gully', 'Stony Ground'],
        ['Track/ Path/ Ride', 'Cliff/ Crag', 'Contour', 'Earth Bank'],
        ['Boulder', 'Green Vegetation', 'Stony Ground', 'Contour'],
        ['Boulder', 'Green Vegetation', 'Cliff/ Crag', 'Contour'],
      ],
      questions: [
        'What has changed?',
        'How many bushes / small trees are missing?',
        'How many symbols have changed?',
        'How many extra knolls and boulders are there?',
        'What has changed?',
        'What has changed?',
        'What has changed?',
        'What has changed?',
        'What has changed?',
        'What has changed?',
        'What has changed?',
        'What has changed?',
      ],
    }
  },

  methods: {
    lookupComp: async function(id) {
      try {
        if (this.currentStage === 'name')
          this.users = await db
            .collection('wod')
            .doc(id.toString())
            .get()
            .then(result => ({ id, ...result?.data() }))
      } catch (error) {
        this.users = {}
      }
    },

    startCountdown: function(user) {
      this.user = user
      this.setUserStarted(user.id)
      this.currentStage = 'countdown'
    },

    setUserStarted: function(userId) {
      return db
        .collection('wod')
        .doc(userId.toString())
        .update({ started: true, device: navigator.userAgent })
    },

    saveUserResult: function() {
      return Promise.resolve()
      /*
      return Promise.all([
        this.saveToMainDatabase({
          id: parseInt(this.user.id, 10),
          username: this.user.name.trim(),
          score: this.userScoreNumber.toString(),
          time: (this.userTime / 1000).toFixed(2).toString(),
        }),

        db
          .collection('wod')
          .doc(this.user.id.toString())
          .update({
            choices: this.choices,
            times: this.times,
            score: this.userScoreNumber,
            time: this.userTime,
          }),
      ])
        .then(() => {
          this.error = 0
        })
        .catch(err => {
          console.log(err)
          this.error = 2
        }) */
    },

    saveToMainDatabase: function(result) {
      if (this.user.id > 20)
        return fetch(
          'https://europe-west3-coursechoicegame.cloudfunctions.net/saveSpot',
          {
            method: 'POST',
            mode: 'no-cors',
            body: JSON.stringify(result),
          }
        ).then(async response => {
          console.log('response', await response.text())
        })
      else return Promise.resolve()
    },

    startGame: function() {
      this.currentStage = 'puzzle'
    },

    puzzleComplete: function(result) {
      this.choices.push(result.choice)
      this.times.push(result.time)

      if (this.puzzleNumber === this.solution.length) {
        this.currentStage = 'gameover'

        this.userScore = this.scoreUser()
        this.userTime = this.times.reduce((a, b) => a + b, 0)

        this.saveUserResult()
      } else this.currentStage = 'pause'
    },

    nextPuzzle: function() {
      this.puzzleNumber += 1
      this.currentStage = 'puzzle'
    },

    displayTime: function(milliseconds) {
      const minutes = Math.floor(milliseconds / 60000)
      const millisecondsOverMinutes = milliseconds - minutes * 60000
      const seconds = Math.round(millisecondsOverMinutes / 10) / 100

      return `${this.twoDigits(minutes)}:${this.twoDigits(seconds)}`
    },

    twoDigits: function(number) {
      const splitNumber = number.toString().split('.')
      if (splitNumber.length > 1 && splitNumber[0].toString().length < 2)
        return `0${splitNumber[0].toString()}.${splitNumber[1]}`
      else if (number.toString().length < 2) return `0${number.toString()}`
      else return number
    },

    scoreUser: function() {
      let correct = 0
      let i = 0

      while (i < this.choices.length) {
        if (this.solution[i] === this.choices[i]) correct += 1
        i += 1
      }

      this.userScoreNumber = correct
      return `${correct}`
    },
  },
}
</script>
